module.exports = __webpack_public_path__ + "static/media/services_interiordesign.3b4b1d46.jpg";